(function () {
	container = document.querySelector('.announcement-bar-container');

	if (!container.children.length) return;
	let currentIndex = 0;
	function rotateCarousel() {
	  currentIndex++;
	  if (currentIndex >= container.children.length) {
		currentIndex = 0;
	  }
	  const translateValue = -currentIndex * 100;
	  const animation = container.animate({ 
		transform: `translateX(${translateValue}vw)` },
		{
		  duration: 2000, 
		  easing: 'ease-in-out',
		  fill: 'forwards',
		})
	}

	setInterval(rotateCarousel, 5000);
})()

  

